import type { FaireProductEntity } from "../../entity_types/product";

export const p_5g2w7q9u17: FaireProductEntity = {
  token: "p_5g2w7q9u17",
  type: "product",
  name: "Olive Branches Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/01df822b9ef7447196ea156e8be21dc4e749be23105ce909e0b6e2166cec4464.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0769ea01de573cb0e6b4ce2160f23f88b643d0ba751b28c78e96b6bcb58170f.jpeg",
    "https://cdn.faire.com/fastly/6aa0bcde05cc13eacaa8b12d7cc67f47e9c223dbaf7ae30adba12bb7023cd2e5.jpeg",
    "https://cdn.faire.com/fastly/929fa685171a8efc1007a844dac31f19afd698c62d1cf3214221d986fa204422.jpeg",
    "https://cdn.faire.com/fastly/2f81d08a0533d3824997ab80e951293a9c1b97f7a226ad06ee834710edc8b77c.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:11.723Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
